import { batch } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import {
    createRequest,
    RequestDto as ICreateRequestBodyDto,
    ResponseDto as ICreateRequestResponseDto,
} from '@r1-frontend/api-domru/api-profile/v2/change-tariff/create-request';

import { setLoading, setRequestId, setStep } from '~/src/features/tariffBuilder/actions';
import { TCtxDispatch } from '~/src/features/tariffBuilder/Ctx';
import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { getSelectedEntitiesCurrentTariff } from '~/src/features/tariffBuilder/selectors/getSelectedEntities';
import isSelectedDecoderInCurrentTariff from '~/src/features/tariffBuilder/selectors/isSelectedDecoderInCurrentTariff';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { ESteps } from '~/src/features/tariffBuilder/types/ESteps';

const createRequestThunk = () => async(dispatch: TCtxDispatch, getState: () => TInitialState) => {
    dispatch(setLoading(true));
    const state = getState();
    const selectedEquip = getSelectedEntitiesCurrentTariff(state);
    const isSelectedDecoder = isSelectedDecoderInCurrentTariff(state);
    const clientInfo = state.client;
    const planId = state.planId;
    const salePackageId = state.salePackageId;
    const { contactPhone, phone } = clientInfo;

    const routers = selectedEquip.items.filter(el => el.type === EEntity.routers);
    const [firstRouter] = routers;
    const [firstDecoder] = selectedEquip.items.filter(el => el.type === EEntity.decoders);

    const requestBody: ICreateRequestBodyDto = {
        connectInt: routers.length > 0 ? 3 : 0,
        connectTv: isSelectedDecoder ? 2 : 0,
        planId,
        operTypeInt: firstRouter?.planType,
        numberPhone: phone ? Number(phone) : undefined,
        contactId: contactPhone?.isContactId ? Number(contactPhone.value) : undefined,
        promoId: salePackageId ? Number(salePackageId) : undefined,

        operTypeTv: firstDecoder?.planType,

        routerId: firstRouter?.id,
        leasingPriceMonthInt: firstRouter?.monthly,
        leasingDurationInt: firstRouter?.duration,

        boxtvId: firstDecoder?.id,
        leasingPriceMonthTv: firstDecoder?.monthly,
        leasingDurationTv: firstDecoder?.duration,
    };

    const response = await doRequest.apiProfile<ICreateRequestResponseDto>(createRequest(requestBody));

    if (response.isSuccess) {
        batch(() => {
            dispatch(setRequestId(response.payload.request_id));
            dispatch(setStep(ESteps.SelectVisitData));
        });
    } else {
        dispatch(setStep(ESteps.Final));
    }

    dispatch(setLoading(false));
};

export default createRequestThunk;
